import React from 'react';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { withStyles } from '@material-ui/core/styles';

import { LanguageNames } from 'lib/languages';

const styles = theme => ({
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit
  }
});

class WishForm extends React.Component {
  state = {
    lang: Object.keys(LanguageNames)[0],
  };

  handleTabChange = (event, lang) => {
    this.setState({ lang });
  }

  handleChange = field => event => {
    const { onChange } = this.props;

    let value;

    if (field === "visible") {
      value = event.target.checked;
    } else if (field === "price") {
      value = parseFloat(event.target.value);
      if (isNaN(value)) {
        value = 0;
      }
    } else  {
      value = event.target.value;
    }

    onChange && onChange(field, value);
  }

  handleKeyDown = event => {
    const { onConfirm } = this.props;

    if (event.keyCode === 13) {
      onConfirm && onConfirm()
    }
  }

  renderForm() {
    const { wish, classes } = this.props;

    return (
      <div>
        <div>
          <FormControlLabel
            control={
              <Checkbox
                checked={ wish.visible }
                onChange={ this.handleChange('visible') }
              />
            }
            label="Visible"
          />
        </div>
        <TextField
          onChange={ this.handleChange('url') }
          onKeyDown={ this.handleKeyDown }
          placeholder="URL"
          variant="outlined"
          className={ classes.textField }
          value={ wish.url || '' }
        />
        <TextField
          onChange={ this.handleChange('price') }
          onKeyDown={ this.handleKeyDown }
          placeholder="Price"
          variant="outlined"
          className={ classes.textField }
          value={ wish.price || '' }
        />
        <Select
          value={ wish.currency }
          onChange={ this.handleChange('currency') }
          input={
            <OutlinedInput
              name="currency"
              id="outlined-currency-simple"
              labelWidth={ 100 }
            />
          }
        >
          <MenuItem value="euro">€</MenuItem>
          <MenuItem value="ils">₪</MenuItem>
        </Select>
        <TextField
          onChange={ this.handleChange('storeName') }
          onKeyDown={ this.handleKeyDown }
          placeholder="Store Name"
          variant="outlined"
          className={ classes.textField }
          value={ wish.storeName || '' }
        />
        <TextField
          onChange={ this.handleChange('imageUrl') }
          onKeyDown={ this.handleKeyDown }
          placeholder="Image URL"
          variant="outlined"
          className={ classes.textField }
          value={ wish.imageUrl || '' }
        />
        <FormControl variant="outlined">
          <InputLabel
            ref={ref => {
              this.InputLabelRef = ref;
            }}
            htmlFor="outlined-from-simple"
          >
            From
          </InputLabel>
          <Select
            value={ wish.from }
            onChange={ this.handleChange('from') }
            input={
              <OutlinedInput
                name="from"
                id="outlined-from-simple"
                labelWidth={ 100 }
              />
            }
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            <MenuItem value="germany">Germany</MenuItem>
            <MenuItem value="israel">Israel</MenuItem>
          </Select>
        </FormControl>
      </div>
    );
  }

  renderLanguageSpecificTabs() {
    return (
      <Paper square>
        <Tabs
          value={ this.state.lang }
          indicatorColor="primary"
          textColor="primary"
          onChange={ this.handleTabChange }
        >
          {
            Object.keys(LanguageNames).map(lang =>
              <Tab label={ LanguageNames[lang] } value={ lang } key={ lang } />)
          }
        </Tabs>
      </Paper>
    );
  }

  renderLanguageSpecificForm() {
    const { lang } = this.state;
    const { wish, classes } = this.props;

    const titleKey = `title_${lang}`;
    const descriptionKety = `description_${lang}`;

    return (
      <div className="lang">
        <TextField
          onChange={ this.handleChange(titleKey) }
          onKeyDown={ this.handleKeyDown }
          placeholder="Title"
          variant="outlined"
          className={ classes.textField }
          value={ wish[titleKey] || '' }
          key={ titleKey }
        />

        <TextField
          onChange={ this.handleChange(descriptionKety) }
          onKeyDown={ this.handleKeyDown }
          placeholder="Description"
          variant="outlined"
          className={ classes.textField }
          value={ wish[descriptionKety] || '' }
          multiline
          key={ descriptionKety }
        />
      </div>
    );
  }

  render() {
    const { wish } = this.props;
    const notEmpty = Object.keys(wish).length > 0

    return notEmpty && (
      <div className="WishForm">
        { this.renderForm() }
        { this.renderLanguageSpecificTabs() }
        { this.renderLanguageSpecificForm() }
      </div>
    );
  }
}

export default withStyles(styles)(WishForm);



// WEBPACK FOOTER //
// ./src/components/WishForm/WishForm.js